// Target blank
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// masonry grid
let productLists = document.querySelectorAll('.shopify-section--featured-collections product-list.product-list');
productLists.forEach(productList => {
  if (!productList) return;
  let msnry = new Masonry(productList, { itemSelector: '.product-card', columnWidth: '.product-card', percentPosition: true });
})

let collectionLists = document.querySelectorAll('.shopify-section--main-list-collections .collection-list');
collectionLists.forEach(collectionList => {
  if (!collectionList) return;
  let msnry = new Masonry(collectionList, { itemSelector: '.collection-card', columnWidth: '.collection-card', percentPosition: true });
})

let blogpostLists = document.querySelectorAll('.shopify-section.shopify-section--main-blog .blog-post-list');
blogpostLists.forEach(blogpostList => {
  if (!blogpostList) return;
  let msnry = new Masonry(blogpostList, { itemSelector: '.blog-post-card', columnWidth: '.blog-post-card', percentPosition: true });
})

customElements.define('savings-price',
  class extends HTMLElement {
    constructor() {
      super();
      document.forms[this.getAttribute("form")]?.addEventListener("variant:change", e => {
        this.querySelectorAll(".savings-price-text").forEach(textDiv => {
          if (textDiv.dataset.variant == e.detail.variant.id) textDiv.setAttribute("active", '');
          else textDiv.removeAttribute('active');
        });
      });
    }
});

customElements.define('soldout-price',
  class extends HTMLElement {
    constructor() {
      super();
      this.priceList = this.closest('price-list');
      if(!this.priceList) return;
      document.forms[this.getAttribute("form")]?.addEventListener("variant:change", e => {
        if(e.detail.variant.available) this.priceList.removeAttribute('soldout')
        else this.priceList.setAttribute('soldout', '')
      });
    }
});

customElements.define('new-badge',
  class extends HTMLElement {
    constructor() {
      super();
      window.themeVariables.settings.newBadgeDays && this.dataset.created && this.toggleVisibility();
    }

    toggleVisibility() {
      const createdDate = new Date(this.dataset.created).getTime();
      const nowDate = new Date().getTime();

      // Calculate the difference in milliseconds
      const timeDifference = nowDate - createdDate;

      // Calculate the number of days
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

      // Check if the date is within the new badge limit set in theme settings
      if (daysDifference <= window.themeVariables.settings.newBadgeDays) this.classList.remove('hidden');
    }

});

customElements.define('artist-search',
  class ArtistSearch extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.artistSearchGrid = this.querySelector('.artist-search-grid');
      this.letters = this.querySelectorAll('.artist-search-letters span');
      this.searchInput = this.querySelector('.artist-search-input input');
      this.pagesCount = this.dataset.pagesCount;
      this.sectionId = this.dataset.sectionId;

      this.searchInput.addEventListener('change', (e) => {
        this.search(e.currentTarget.value);
        this.letters.forEach(letter => letter.classList.remove('active'));
      });
      
      this.letters.forEach(clickedLetter => clickedLetter.addEventListener('click', (e) => {
          if (clickedLetter.classList.contains('active')) {
            this.search('');
            this.letters.forEach(letter => letter.classList.remove('active'));
          }
          else {
            this.search(e.currentTarget.innerText, true);
            this.letters.forEach(letter => letter.classList.remove('active'));
            clickedLetter.classList.add('active');
          }
          this.searchInput.value = '';
        }
      ))
      
      
      if(this.pagesCount == 1) return this.setMasonry();
      
      for(let i = 2; i <= this.pagesCount; i++) {
        this.requestURL = location.hostname + location.pathname + '?sections=' + this.sectionId + '&page=' + i;
        this.getContent(this.requestURL)
      }
    }

    async getContent(apiUrl) {
      try {
        const response = await fetch(apiUrl);
    
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const container = document.createElement('div');
        const data = await response.json();
        const firstKey = Object.keys(data)[0];
        container.innerHTML = data[firstKey];
        const content = container.querySelector('.artist-search-grid');
        this.appendResults(content);
      } catch (error) {
        console.error('Error:', error);
      }
    }
    
    appendResults(content) {
      if(!content) return;
      this.artistSearchGrid.innerHTML = this.artistSearchGrid.innerHTML + content.innerHTML;
      this.setMasonry();
    }

    search(param, clickedLetter) {
      param = param.toLowerCase();
      let collectionDivs = this.querySelectorAll('.artist-search-item');
      collectionDivs.forEach(collectionDiv => {
        collectionDiv.classList.remove('active');

        if (param == '') {
          collectionDiv.classList.add('active');
          this.letters.forEach(letter => letter.classList.remove('active'));
          return;
        }

        if (clickedLetter) {
          let splitTitle = collectionDiv.dataset.title.split(' '); 
          let lastName = splitTitle[splitTitle.length - 1];
          if (lastName.split('')[0] === param) return collectionDiv.classList.add('active');
        } 
        else {
          let paramParts = param.split(' ');
          paramParts.forEach(part => {
            if (collectionDiv.dataset.title.indexOf(part) !== -1) return collectionDiv.classList.add('active');
          })
        }
      });

      this.setMasonry();
    }

    setMasonry() {
      let msnry = new Masonry(this.artistSearchGrid, { itemSelector: '.artist-search-item.active', columnWidth: '.artist-search-item.active', percentPosition: true });
    }
});

// Abz marquee
jQuery(document).ready(function ($) {
  $('.slick.marquee').slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable: false,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });
});

// Abz works slider
jQuery(document).ready(function ($) {
  $('.slick.works').slick({
    autoplay: false,
    slidesToShow: 3,
    draggable: false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: true,
    buttons: false
  });
});

// Blog Post slider
$(document).ready(function () {
  $('.slick-blog').slick({
    arrows: true,
    centerPadding: "0px",
    dots: true,
    slidesToShow: 1,
    infinite: false,
    adaptiveHeight: true
  });
});

// Pages slider
$(document).ready(function () {
  $('.slick-pages').slick({
    arrows: true,
    centerPadding: "0px",
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    autoplay: true
  });
});

// Collection Inner
$(document).ready(function () {
  $('.collection-inner').slick({
    arrows: true,
    centerPadding: "0px",
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    autoplay: true
  });
});

